/* eslint-disable parog-web/no-glint-expect-error-directive */
import { on } from '@ember/modifier';
import type Owner from '@ember/owner';
import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
import Base from 'parog-web/components/forc/provider/base';
import { dateMonthYearFormat } from 'parog-web/helpers/datepicker-format';
import createAutoSaveChangeset from 'parog-web/utils/create-auto-save-changeset';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    onDestroy?: () => void;
    title: string;
    model: EmberChangeset;
    index: number;
    onDirty: () => void;
  };
}

export default class DigestSuregeriesComponent extends Component<Signature> {
  changeset: EmberChangeset;
  formatter = {
    date: dateMonthYearFormat
  };

  get surgeries(): string[] {
    return this.args.title == 'Chirurgie digestive'
      ? [
          'Resection iléo-colique',
          'resection intestinale',
          'colectomie subtotale',
          'colectomie segmentaire',
          'coloproctectomie',
          'proctectomie',
          'iléostomie',
          'colostomie',
          'stricturoplastie',
          'retablissement',
          'autre'
        ]
      : [
          'drainage',
          'lambeau muqueux',
          'gracilis',
          'injection de cellules souches',
          'injection biothérapie'
        ];
  }

  constructor(owner: Owner, args: Signature['Args']) {
    super(owner, args);
    this.changeset = createAutoSaveChangeset(this.args.model);
    this.changeset.on('afterValidation', () => {
      this.args.onDirty();
    });
  }

  <template>
    <Base @changeset={{this.changeset}} @isReadOnly={{false}} as |Form|>
      <div class='ui segment'>

        <h5 class='ui dividing header'>{{@title}}</h5>
        <i
          class='trash icon absolute right-[1em] top-[1em]'
          role='button'
          {{! @glint-expect-error }}
          {{on 'click' @onDestroy}}
        >
        </i>

        <div class='field'>
          <Form.Dropdown
            @labelName='Chirurgies'
            @placeholder='Chirurgies'
            @propertyName='surgeries'
            @multipleSelection={{true}}
            as |dropdown|
          >
            {{#each this.surgeries as |surgerie|}}
              <dropdown.Item @key={{surgerie}} @value={{surgerie}} />
            {{/each}}
          </Form.Dropdown>

        </div>
        <div class='field'>
          <Form.Date
            @propertyName='year'
            @labelName='Année'
            @formatter={{this.formatter}}
          />
        </div>
      </div>
    </Base>
  </template>
}
